import React from 'react';
import PropTypes from 'prop-types';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import Heading from '../../atoms/Heading';
import styles from './userInfo.module.scss';
var USER_INFO_SEPARATOR = ', ';
var UserInfo = function UserInfo(props) {
  var _props$userName = props.userName,
    userName = _props$userName === void 0 ? '' : _props$userName,
    userRole = props.userRole;
  return /*#__PURE__*/React.createElement(Heading, {
    size: 4,
    className: "flex align-items-center"
  }, /*#__PURE__*/React.createElement("div", null, userName), /*#__PURE__*/React.createElement("div", {
    className: styles.userInfoSeparator
  }, USER_INFO_SEPARATOR), /*#__PURE__*/React.createElement("div", {
    className: styles.userRole
  }, userRole));
};
UserInfo.propTypes = {
  userName: PropTypes.string.isRequired,
  userRole: PropTypes.string
};
UserInfo.defaultProps = {
  userRole: EMPTY_STRING
};
export default UserInfo;